import AdminCreat from "../View/Admin/Create";
import AdminList from "../View/Admin/List";
import Createblog from "../View/Blog/Create";
import BlogEdit from "../View/Blog/Edite";
import Listblog from "../View/Blog/List";
import CreateContentBox from "../View/ContentBox/Create";
import ContentBoxEdit from "../View/ContentBox/Edite";
import ListContentBox from "../View/ContentBox/List";
import CreateBlogCategory from "../View/BlogCategory/Create";
import ListBlogCategory from "../View/BlogCategory/List";
import CreateCategory from "../View/Category/Create";
import ListCategory from "../View/Category/List";
import CreateClass from "../View/Classes/Pages/CreateClass";
import EditClass from "../View/Classes/Pages/Edit";
import ClassList from "../View/Classes/Pages/List";
import SingleClass from "../View/Classes/Pages/SingleClass";
import ClassMangerCreate from "../View/ClassManger/Pages/Create";
import ClassMangerList from "../View/ClassManger/Pages/List";
import ActiveComments from "../View/CommentsManagment/ActiveComments";
import Blogs from "../View/CommentsManagment/Components/Blogs";
import DeactiveComments from "../View/CommentsManagment/DeactiveComments";
import ContactUsList from "../View/ContactUs/Page/List";
import ContarctList from "../View/Contract/Pages/index";
import AdminDashboard from "../View/Dashboard/index";
import CreateBySteps from "../View/Items/CreateBySteps";
import ItemEdit from "../View/Items/Edit";
import ItemActiveReact from "../View/Items/Edit/ActiveItemReact/index";
import EditTimeTable from "../View/Items/Edit/EditTimeTable";
import SansCount from "../View/Items/Edit/SansCount/index";
import SansWcountWGender from "../View/Items/Edit/SansCountGender/index";
import SansWgender from "../View/Items/Edit/SansWgender";
import ItemEditSift from "../View/Items/Edit/Shift/index";
import ShiftDate from "../View/Items/Edit/ShiftDate";
import ItemList from "../View/Items/List";
import ContractualReservationPriceChanges from "../View/Items/ContractualReservationPriceChanges";
import ManagerList from "../View/Managers/List";
import OfferCreate from "../View/Offer/Create";
import OfferList from "../View/Offer/List";
import CreateOption from "../View/Options/Create";
import ListOption from "../View/Options/List";
import OrderList from "../View/OrderList/List";
import RegionCreate from "../View/Region/Create";
import RegionList from "../View/Region/List";
import ReportList from "../View/Reports/List";
import ReportSingle from "../View/Reports/Single";
import RequestList from "../View/Requests/List";
import RequsetWallet from "../View/RequestWallet/List";
import AppVersion from "../View/Setting/AppVersion";
import ClupSetting from "../View/Setting/Clup/index";
import CompanySetting from "../View/Setting/CompanySetting/index";
import CreateQuestion from "../View/Setting/QuestionsSetting/Create";
import QuestionsSetting from "../View/Setting/QuestionsSetting/List";
import RatingSetting from "../View/Setting/Rating";
import RewardSetting from "../View/Setting/RewardSettings";
import GeneralSettings from "../View/Setting/SettingsGeneral/index";
import SiteSetting from "../View/Setting/SiteSetting/index";
import ShargeUserWallet from "../View/ShargeUserWallet/index";
import TagCreate from "../View/Tag/Create";
import TagList from "../View/Tag/List";
import Chating from "../View/Ticketing/Chating";
import TicketingList from "../View/Ticketing/List";
import UserCreate from "../View/Users/Create";
import UserList from "../View/Users/List";
import OrderDetails from "../../Common/Components/OrderDetails";
import TimeReservesList from "../../Common/Components/TimeReservesList/Page";
import SubmitUsers from "../View/Items/SubmitUsers";
import UserProblemList from "../View/UserProblem/Pages/index";
import StoreUserProblemList from "../View/UserProblem/Pages/Create";
import CategoryQuestionsSetting from "../View/Setting/QuestionsCategorySetting/List";
import CategoryQuestionsSettingCreate from "../View/Setting/QuestionsCategorySetting/Create";
import RulesList from "../View/Rules/Pages/List";
import CreateRole from "../View/Rules/Pages/Create";
import EditRole from "../View/Rules/Pages/Edit";
import ListPages from "../View/Pages/List";
import CreatePages from "../View/Pages/Create";
export const routes = [
  {
    path: "/Admin/Item/SubmitUsers/:item_id",
    exact: true,
    component: SubmitUsers,
    name: "SubmitUsers",
    sub: "0",
    label: "ویرایش باشگاه",
  },
  {
    path: "/Admin/Dashboard",
    sub: "",
    component: AdminDashboard,
    name: "AdminDashboard",
    label: "داشبورد ادمین",
    icon: "icon ti-dashboard",
    access: "HCyH3IkLArXwjxf",
  },

  {
    path: "/Admin/OrderList",
    sub: "",
    component: OrderList,
    name: "OrderList",
    label: "مدیریت فروش",
    access: "sDT0PHOPIQLQ31l",
    icon: "icon ti-receipt",
  },

  {
    subscribe: true,
    name: "Items",
    label: "مدیریت مجموعه ها",
    icon: "icon ti-icon ti-view-list-alt",
    path: "",
    access: "ItiWea3GbSA5ms2",
  },
  {
    path: "/Admin/Item/CreateBySteps",
    exact: true,
    component: CreateBySteps,
    name: "CreateBySteps",
    sub: "Items",
    access: "ItiWea3GbSA5ms2",
    label: " ایجاد مجموعه",
  },
  {
    path: "/Admin/Item/List",
    exact: true,
    component: ItemList,
    name: "ItemList",
    sub: "Items",
    access: "ItiWea3GbSA5ms2",
    label: "لیست مجموعه ها",
  },
  {
    path: "/Admin/ContractualReservationPriceChanges",
    exact: true,
    component: ContractualReservationPriceChanges,
    name: "ItemList",
    sub: "Items",
    access: "ItiWea3GbSA5ms2",
    label: "تغییر قیمت رزرو قراردادی",
  },
  {
    path: "/Admin/Item/Edit/:slug",
    exact: true,
    component: ItemEdit,
    name: "ItemEdit",
    access: "ItiWea3GbSA5ms2",
    sub: "0",
    label: "ویرایش مجموعه",
  },
  {
    path: "/Admin/Item/EditShift/:slug",
    exact: true,
    component: ItemEditSift,
    name: "ItemEdit",
    sub: "0",
    access: "ItiWea3GbSA5ms2",
    label: "ویرایش باشگاه",
  },
  {
    path: "/Admin/Item/ShiftDate/:slug",
    exact: true,
    component: ShiftDate,
    name: "ItemEdit",
    sub: "0",
    access: "ItiWea3GbSA5ms2",
    label: "ویرایش باشگاه",
  },
  {
    path: "/Admin/Item/ItemActive/:slug",
    exact: true,
    component: ItemActiveReact,
    name: "ItemEdit",
    sub: "0",
    access: "ItiWea3GbSA5ms2",
    label: "فعال کردن مجموعه",
  },
  {
    path: "/Time/Reserve/:inint",
    exact: true,
    component: TimeReservesList,
    name: "TimeReservesList",
    sub: "0",
    access: "ItiWea3GbSA5ms2",
    label: "رزرو های تایم",
  },

  {
    path: "/Admin/Item/EditTimeTable/:slug",
    exact: true,
    component: EditTimeTable,
    name: "EditTimeTable",
    access: "ItiWea3GbSA5ms2",
    sub: "0",
  },
  {
    path: "/Admin/Item/SansWgender/:slug",
    exact: true,
    component: SansWgender,
    name: "ItemEdit",
    sub: "0",
    access: "ItiWea3GbSA5ms2",
    label: "ویرایش سانس",
  },
  // SansWgender
  {
    path: "/Admin/Item/SansCount/:slug",
    exact: true,
    component: SansCount,
    name: "ItemEdit",
    sub: "0",
    access: "ItiWea3GbSA5ms2",
    label: "ویرایش سانس با ظرفیت",
  },
  {
    path: "/Admin/Item/SansWcountWGender/:slug",
    exact: true,
    component: SansWcountWGender,
    name: "ItemEdit",
    sub: "0",
    access: "ItiWea3GbSA5ms2",
    label: "ویرایش سانس با ظرفیت",
  },
  {
    path: "/Admin/Category/List",
    exact: true,
    component: ListCategory,
    name: "ListCategory",
    sub: "Items",
    access: "ItiWea3GbSA5ms2",
    label: "دسته بندی",
  },
  {
    path: "/Admin/Category/Create",
    exact: true,
    component: CreateCategory,
    name: "CreateCategory",
    sub: "Category",
    access: "ItiWea3GbSA5ms2",
    label: "ایجاد دسته بندی",
  },

  {
    path: "/Admin/Option/List",
    exact: true,
    component: ListOption,
    name: "ListOption",
    access: "ItiWea3GbSA5ms2",
    sub: "Items",
    label: "امکانات",
  },
  {
    path: "/Admin/Option/Create",
    exact: true,
    component: CreateOption,
    name: "CreateOption",
    access: "ItiWea3GbSA5ms2",
    sub: "Option",
    label: "ایجاد امکانات",
  },
  {
    subscribe: true,
    name: "Classes",
    label: "مدیریت کلاس ها",
    path: "",
    access: "H0mCn6O1TGIP97t",
    icon: "icon ti-icon ti-user",
  },
  {
    path: "/Admin/ClassManger/List",
    exact: true,
    component: ClassMangerList,
    name: "ClassMangerList",
    sub: "Classes",
    access: "H0mCn6O1TGIP97t",
    label: "لیست برگزار کننده ها",
  },
  {
    path: "/Admin/Classes/List/:slug",
    exact: true,
    component: ClassList,
    name: "ClassList",
    access: "H0mCn6O1TGIP97t",
    sub: "0",
    label: "لیست کلاس ها ",
  },
  {
    path: "/Admin/Classes/CreateClass/:slug",
    exact: true,
    component: CreateClass,
    access: "H0mCn6O1TGIP97t",
    name: "CreateClass",
    sub: "0",
    label: " ایجاد کلاس ",
  },
  {
    path: "/Admin/EditClass",
    exact: true,
    component: EditClass,
    name: "EditClass",
    access: "H0mCn6O1TGIP97t",
    sub: "0",
    label: " ویرایش کلاس ",
  },
  {
    path: "/Admin/SingleClass",
    exact: true,
    component: SingleClass,
    name: "SingleClass",
    access: "H0mCn6O1TGIP97t",
    sub: "0",
    label: "مشاهده کلاس",
  },
  // SingleClass
  {
    path: "/Admin/ClassManger/create",
    exact: true,
    component: ClassMangerCreate,
    name: "ClassMangerCreate",
    access: "H0mCn6O1TGIP97t",
    sub: "Classes",
    label: "ایجاد برگزار کننده ",
  },
  {
    subscribe: true,
    name: "Pages",
    label: "مدیریت صفحات",
    path: "",
    icon: "icon ti-book",
  },
  {
    path: "/Admin/pages/List",
    exact: true,
    component: ListPages,
    name: "ListPages",
    sub: "Pages",
    access: "SStE6mZ41iRWGoL",
    label: "لیست صفحات",
  },
  {
    path: "/Admin/pages/Create",
    exact: true,
    component: CreatePages,
    name: "CreatePages",
    sub: "Pages",
    access: "SStE6mZ41iRWGoL",
    label: "ایجاد صفحات",
  },
  {
    subscribe: true,
    name: "Blog",
    label: "مدیریت مجله",
    path: "",
    access: "SStE6mZ41iRWGoL",
    icon: "icon ti-book",
  },
  {
    path: "/Admin/blog/List",
    exact: true,
    component: Listblog,
    name: "Listblog",
    sub: "Blog",
    access: "SStE6mZ41iRWGoL",
    label: "لیست مقالات",
  },
  {
    path: "/Admin/blog/crate",
    exact: true,
    component: Createblog,
    name: "Createblog",
    sub: "Blog",
    access: "SStE6mZ41iRWGoL",
    label: "ایجاد مقاله",
  },
  {
    path: "/Admin/blog/edit/:slug",
    exact: true,
    component: BlogEdit,
    name: "ItemEdit",
    sub: "0",
    access: "SStE6mZ41iRWGoL",
    label: "ویرایش مقاله",
  },
  {
    path: "/Admin/ContentBox/List",
    exact: true,
    component: ListContentBox,
    name: "ListContentBox",
    sub: "",
    access: "SStE6mZ4asdsGoL",
    label: "مدیریت باکس های محتوا",
  },
  {
    path: "/Admin/ContentBox/create",
    exact: true,
    component: CreateContentBox,
    name: "CreateContentBox",
    sub: "0",
    access: "SStE6mZ41iasdL",
    label: "ایجاد باکس",
  },
  {
    path: "/Admin/ContentBox/edit/:id",
    exact: true,
    component: ContentBoxEdit,
    name: "ContentBoxEdit",
    sub: "0",
    access: "SasdE6mZ41iRWGoL",
    label: "ویرایش باکس",
  },


  {
    path: "/Admin/blogCategory/List",
    exact: true,
    component: ListBlogCategory,
    name: "Listblog",
    sub: "Blog",
    access: "SStE6mZ41iRWGoL",
    label: "لیست دسته بندی مقالات",
  },
  {
    path: "/Admin/blogCategory/crate",
    exact: true,
    component: CreateBlogCategory,
    name: "Createblog",
    sub: "Blog",
    access: "SStE6mZ41iRWGoL",
    label: "ایجاد دسته بندی مقاله",
  },
  {
    path: "/Admin/blogCategory/edit/:slug",
    exact: true,
    component: BlogEdit,
    name: "ItemEdit",
    sub: "0",
    access: "SStE6mZ41iRWGoL",
    label: "ویرایش  مقاله",
  },

  {
    path: "/Admin/Comments/blogs/:id",
    name: "Blog",
    exact: true,
    component: Blogs,
    access: "SStE6mZ41iRWGoL",
    label: "مجموعه",
    icon: null,
  },
  {
    subscribe: true,
    name: "comments",
    label: "مدیریت کامنت ها",
    path: "",
    access: "6ioG80a7o2n7AYb",
    icon: "icon ti-comment",
  },
  {
    path: "/Admin/ActiveComments",
    exact: true,
    component: ActiveComments,
    access: "6ioG80a7o2n7AYb",
    sub: "comments",
    label: "کامنت های فعال",
  },
  {
    path: "/Admin/DeactiveComments",
    exact: true,
    component: DeactiveComments,
    access: "6ioG80a7o2n7AYb",
    sub: "comments",
    label: "کامنت های غیر فعال",
  },
  {
    path: "/Admin/Rules",
    sub: "",
    component: RulesList,
    name: "RulesList",
    access: "uKQHaNT4qYQnQrR",
    label: "مدیریت نقش ها",
    icon: "icon ti-receipt",
  },
  {
    path: "/Admin/Rules/Create",
    exact: true,
    component: CreateRole,
    name: "RulesCreate",
    access: "uKQHaNT4qYQnQrR",
    sub: "0",
  },
  {
    path: "/Admin/Rules/Update/:slug",
    exact: true,
    component: EditRole,
    access: "uKQHaNT4qYQnQrR",
    name: "RulesEdit",
    sub: "0",
  },
  {
    subscribe: true,
    name: "Users",
    label: "مدیریت کاربران",
    access: "x6QFbkruZ9GXgBS",
    path: "",
    icon: "icon ti-icon ti-user",
  },
  {
    path: "/Admin/User/Create",
    exact: true,
    component: UserCreate,
    name: "UsersCreate",
    sub: "Users",
    access: "x6QFbkruZ9GXgBS",
    label: "ثبت کاربر",
  },
  {
    path: "/Admin/User/List",
    exact: true,
    component: UserList,
    name: "UsersList",
    access: "x6QFbkruZ9GXgBS",
    sub: "Users",
    label: "لیست کاربران",
  },
  {
    path: "/Admin/UserShargeWaller",
    sub: "Users",
    component: ShargeUserWallet,
    name: "ShargeUserWallet",
    access: "Hf8zLu6tT41WlnW",
    label: "شارژ کیف پول کاربر",
    icon: "icon ti-dashboard",
  },
  {
    path: "/Admin/Manager/List",
    exact: true,
    component: ManagerList,
    name: "ManagersList",
    sub: "Users",
    access: "iNsQPgRA15hLntU",
    label: "مدیران",
  },
  {
    path: "/Admin/admin/Create",
    exact: true,
    component: AdminCreat,
    name: "AdminCreat",
    sub: "Admins",
    access: "iNsQPgRA15hLntU",
    label: "ثبت ادمین",
  },

  {
    path: "/Admin/admin/List",
    exact: true,
    component: AdminList,
    name: "AdminList",
    access: "iNsQPgRA15hLntU",
    sub: "Users",
    label: "ادمین ها",
  },
  {
    subscribe: true,
    name: "UserProblem",
    path: "",
    label: "مشکلات کاربران",
    access: "7zX3LOwZ6DD42dx",
    icon: "icon ti-file",
  },
  {
    path: "/Admin/UserProble/store",
    sub: "UserProblem",
    component: StoreUserProblemList,
    name: "Problems",
    access: "7zX3LOwZ6DD42dx",
    label: "ثبت مشکل کاربر",
  },
  {
    path: "/Admin/UserProble",
    sub: "UserProblem",
    component: UserProblemList,
    name: "Problems",
    access: "7zX3LOwZ6DD42dx",
    label: "لیست کاربران مشکل دار",
  },
  {
    subscribe: true,
    name: "Requests",
    path: "",
    label: "مدیریت درخواست ها",
    icon: "icon ti-file",
  },
  {
    path: "/Admin/Requests",
    sub: "Requests",
    component: RequestList,
    name: "Requests",
    access: "rn6tcb4i13LcfQc",
    label: "درخواست های ثبت مجموعه",
  },
  {
    path: "/Admin/RequsetWallet",
    sub: "Requests",
    component: RequsetWallet,
    name: "Requests",
    label: "درخواست برداشت درآمد",
    access: "yD1aVuyUEsZSNQ5",
    icon: "icon ti-wallet",
  },
  {
    path: "/Admin/Contract",
    sub: "Requests",
    component: ContarctList,
    name: "Requests",
    access: "sLNm1s0NaMigJgw",
    label: "قراردادها",
    icon: "icon ti-file",
  },
  {
    path: "/Admin/ContactUsList",
    sub: "Requests",
    component: ContactUsList,
    name: "Requests",
    label: "ارتباط با ما",
    access: "a4WaRV8ah71AjiD",
    icon: "icon ti-file",
  },
  {
    path: "/Admin/ticketing",
    exact: true,
    component: TicketingList,
    access: "YodsAZ5wQhqPkb7",
    name: "Ticketing",
    label: "پشتیبانی",
    sub: "",
    icon: "icon ti-folder",
  },
  {
    subscribe: true,
    name: "offer",
    label: "مدیریت تخفیف ها",
    path: "",
    access: "gB629zLNzAIU50K",
    icon: "icon ti-gift",
  },
  {
    path: "/Admin/Offer/Create",
    exact: true,
    component: OfferCreate,
    access: "gB629zLNzAIU50K",
    sub: "offer",
    label: "ایجاد تخفیف",
  },
  {
    path: "/Admin/Offer/List",
    exact: true,
    access: "gB629zLNzAIU50K",
    component: OfferList,
    sub: "offer",
    label: " لیست تخفیف ها",
  },

  {
    path: "/Admin/Report/Single",
    access: "1mEVNy0pwIrYQHT",
    component: ReportSingle,
  },

  {
    path: "/Admin/Region/List",
    exact: true,
    component: RegionList,
    name: "ListRegion",
    sub: "",
    access: "kYtTRlW7WMRlUv8",
    label: "مناطق",
    icon: "icon ti-location-pin",
  },
  {
    path: "/Admin/Region/Create",
    access: "kYtTRlW7WMRlUv8",
    component: RegionCreate,
  },
  {
    path: "/Admin/Tag/List",
    exact: true,
    sub: "",
    component: TagList,
    name: "ListTag",
    access: "RlXV7b1gD5lj0bB",
    label: " تگ ها",
    icon: "icon ti-tag",
  },
  {
    path: "/Admin/Tag/Create",
    access: "RlXV7b1gD5lj0bB",
    component: TagCreate,
  },
  {
    path: "/Admin/ticketing/chat/:id",
    exact: true,
    component: Chating,
    name: "Chating",
    access: "YodsAZ5wQhqPkb7",
    labale: "چت پشتیبانی",
    icon: null,
  },
  {
    path: "/Admin/OrderDetails/:trackingcodeorder",
    exact: true,
    component: OrderDetails,
    name: "Chating",
    access: "sDT0PHOPIQLQ31l",
    labale: "جزییات سفارش",
    icon: null,
  },
  {
    path: "/Admin/Report",
    exact: true,
    component: ReportList,
    name: "Ticketing",
    label: "گزارش اشکال",
    access: "1mEVNy0pwIrYQHT",
    sub: "",
    icon: "icon ti-folder",
  },
  {
    subscribe: true,
    name: "Setting",
    label: "تنظیمات",
    path: "",
    icon: "icon ti-settings",
  },
  {
    path: "/Admin/GeneralSettings/Form",
    exact: true,
    component: GeneralSettings,
    sub: "Setting",
    name: "GeneralSettings",
    access: "gj3vwni0bok9TvQ",
    label: "تنظیمات  کلی",
  },
  {
    path: "/Admin/SiteSetting",
    exact: true,
    component: SiteSetting,
    sub: "Setting",
    access: "XkfeidJNH5y6jP3",
    name: "SiteSetting",
    label: "اطلاعات سایت",
  },
  {
    path: "/Admin/CompanySetting",
    exact: true,
    component: CompanySetting,
    access: "9sgoHln0qizHjN8",
    sub: "Setting",
    name: "CompanySetting",
    label: "اطلاعات کمپانی",
  },
  // {
  //   path: "/Admin/AboutUs",
  //   exact: true,
  //   component: AboutUsList,
  //   sub: "Setting",
  //   name: "AboutUs",
  //   label: "درباره ما",
  // },

  {
    path: "/Admin/QuestionsSetting",
    exact: true,
    component: QuestionsSetting,
    sub: "Setting",
    access: "1LbPNQyoNTfvyT8",
    name: "QuestionsSetting",
    label: "سوالات متداول",
  },

  {
    path: "/Admin/CategoryQuestionsSetting",
    exact: true,
    component: CategoryQuestionsSetting,
    sub: "Setting",
    name: "QuestionsSetting",
    access: "1ZwwOJDo2ERSYxI",
    label: "دسته بندی سوالات متداول",
  },
  {
    path: "/Admin/RewardSetting",
    exact: true,
    component: RewardSetting,
    sub: "Setting",
    name: "RewardSetting",
    access: "CRAhIfJ000HmqcD",
    label: "تنظیمات پاداش",
  },
  {
    path: "/Admin/RatingSetting",
    exact: true,
    component: RatingSetting,
    sub: "Setting",
    access: "ZYhQatFTExHKWBp",
    name: "RatingSetting",
    label: "تنظیمات امتیازدهی",
  },
  {
    path: "/Admin/Clupsetting",
    exact: true,
    component: ClupSetting,
    access: "Ec3hcij6y5dXSTF",
    sub: "Setting",
    name: "ClupSetting",
    label: "تنظیمات باشگاه مشتریان",
  },
  {
    path: "/Admin/AppVersion",
    exact: true,
    component: AppVersion,
    sub: "Setting",
    access: "xPoWP1tbzES45ii",
    name: "AppVersion",
    label: "تنظیمات ورژن اپ",
  },
  {
    component: CreateQuestion,
    path: "/Admin/QuestionsSestting/Create",
    name: "ایجاد سوال جدید",
    access: "1LbPNQyoNTfvyT8",
  },
  {
    component: CategoryQuestionsSettingCreate,
    path: "/Admin/CategoryQuestionsSetting/Create",
    name: "ایجاد سوال جدید",
    access: "1LbPNQyoNTfvyT8",
  },
  //
];
